import React from 'react';

interface IconProps {
    fillColor?: string;
    height?: number;
    width?: number;
}

const MMSConnected: React.FC<IconProps> = ({ fillColor = '#188DED', height = 24, width = 24 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.5934 16.9532C17.8371 16.7095 17.8371 16.3145 17.5934 16.0708C17.3497 15.8271 16.9546 15.8271 16.7109 16.0708L14.6561 18.1255L13.8494 17.3188C13.6057 17.0751 13.2106 17.0751 12.9669 17.3188C12.7232 17.5625 12.7232 17.9575 12.9669 18.2012L14.2149 19.4492C14.4586 19.6929 14.8537 19.6929 15.0974 19.4492L17.5934 16.9532Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.72 0.63C14.3466 0.21 13.8933 0 13.36 0H4.39998C3.86665 0 3.41331 0.21 3.03998 0.63C2.66665 1.05 2.47998 1.56 2.47998 2.16V20.88C2.47998 21.48 2.66665 21.99 3.03998 22.41C3.41331 22.83 3.86665 23.04 4.39998 23.04H11.9529C10.9663 22.417 10.1664 21.5251 9.65626 20.4673H4.84799C4.36799 20.4673 3.95999 20.2981 3.62399 19.9597C3.28799 19.6213 3.11999 19.2104 3.11999 18.727V2.38023C3.11999 1.89681 3.28799 1.48591 3.62399 1.14752C3.95999 0.809131 4.36799 0.639936 4.84799 0.639936H12.912C13.392 0.639936 13.8 0.809131 14.136 1.14752C14.472 1.48591 14.64 1.89681 14.64 2.38023V11.5524C14.7715 11.539 14.9042 11.5297 15.038 11.5246C11.704 11.6518 9.04014 14.3948 9.04014 17.76C9.04014 21.2063 11.8339 24 15.2801 24C18.7264 24 21.5201 21.2063 21.5201 17.76C21.5201 14.3137 18.7264 11.52 15.2801 11.52L15.28 2.16C15.28 1.56 15.0933 1.05 14.72 0.63ZM9.60587 21.7315C9.60587 22.1639 9.25534 22.5145 8.82294 22.5145C8.39054 22.5145 8.04 22.1639 8.04 21.7315C8.04 21.2991 8.39054 20.9486 8.82294 20.9486C9.25534 20.9486 9.60587 21.2991 9.60587 21.7315ZM20.3316 17.76C20.3316 20.5498 18.07 22.8114 15.2801 22.8114C12.4903 22.8114 10.2287 20.5498 10.2287 17.76C10.2287 14.9702 12.4903 12.7086 15.2801 12.7086C18.07 12.7086 20.3316 14.9702 20.3316 17.76Z"
                fill={fillColor}
            />
        </svg>
    );
};

export default MMSConnected;
